import Tenancies from './Tenancies';

export default Tenancies;